import React from 'react';
import { Link } from 'react-router-dom';

export default function PlantCard({ plant, showDetailsButton = true }) {
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star text-accent"></i>);
    }

    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt text-accent"></i>);
    }

    const remainingStars = 5 - stars.length;
    for (let i = 0; i < remainingStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star text-accent"></i>);
    }

    return stars;
  };

  return (
    <div className="plant-card group mx-auto">
    <div className="card group">
      <div className="relative overflow-hidden">
        <img
          src={plant.image}
          alt={plant.plantName}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 right-2 bg-primary-600 text-white px-2 py-1 rounded-full text-sm font-medium">
          ${plant.price}
        </div>
      </div>

      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">
          {plant.plantName}
        </h3>
        <p className="text-primary-600 font-medium text-sm mb-2">
          {plant.category}
        </p>

        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-1">
            {renderStars(plant.rating)}
            <span className="text-sm text-gray-600 ml-1">({plant.rating})</span>
          </div>
          <span className="text-sm text-gray-600">
            {plant.availableStock} in stock
          </span>
        </div>

        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {plant.description}
        </p>

        {showDetailsButton && (
          <Link
            to={`/plants/${plant.plantId}`}
            className="btn-primary w-full text-center"
          >
            View Details
          </Link>
        )}
      </div>
    </div>
</div>
  );
}